import * as fromDatatype from '../datatype-library/index';

export interface bl_sfa_deal_line_RowInterface {
  
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid : fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid : fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code : fromDatatype.VarcharDatatypeInterface;
  name : fromDatatype.VarcharDatatypeInterface;
  description : fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.GuidDataFieldInterface
  vrsn : fromDatatype.VarcharDatatypeInterface;
  quantity : fromDatatype.IntegerDatatypeInterface;
  unit_price : fromDatatype.NumericDatatypeInterface;
  recurring : boolean
  recurring_period : fromDatatype.IntegerDatatypeInterface;
  recurring_start_date : fromDatatype.TimestampTzDatatypeInterface;
  recurring_end_date : fromDatatype.TimestampTzDatatypeInterface;
  txn_amount: fromDatatype.NumericDatatypeInterface;
  probability : fromDatatype.NumericDatatypeInterface;
}

export class bl_sfa_deal_line_RowClass implements bl_sfa_deal_line_RowInterface {

    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid : fromDatatype.GuidDataFieldInterface;
    fi_item_hdr_guid : fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    code : fromDatatype.VarcharDatatypeInterface;
    name : fromDatatype.VarcharDatatypeInterface;
    description : fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status : fromDatatype.StatusDataFieldInterface
    revision : fromDatatype.GuidDataFieldInterface
    vrsn : fromDatatype.VarcharDatatypeInterface;
    quantity : fromDatatype.IntegerDatatypeInterface;
    unit_price : fromDatatype.NumericDatatypeInterface;
    recurring : boolean
    recurring_period : fromDatatype.IntegerDatatypeInterface;
    recurring_start_date : fromDatatype.TimestampTzDatatypeInterface;
    recurring_end_date : fromDatatype.TimestampTzDatatypeInterface;
    txn_amount: fromDatatype.NumericDatatypeInterface;
    probability : fromDatatype.NumericDatatypeInterface;

}
